
import React from 'react';
import { createUseStyles } from 'react-jss';
import LoginGoogle from './LoginGoogle'
import LoginFacebook from './LoginFacebook';

export interface SocialLoginProps {
    success: Function;
}

const SocialLogin: React.FC<SocialLoginProps> = ({ success }) => {
    const classes = useStyles();

    return (
        <>
            <LoginGoogle success={success}></LoginGoogle>
            <LoginFacebook success={success}></LoginFacebook>
        </>
    )
}

const useStyles = createUseStyles({

});

export default SocialLogin

